import tw from "twin.macro"

export const Svg = tw.svg`
  block
  text-current
  h-full
  w-full
  object-contain
`
